import { render, staticRenderFns } from "./duoTraining.vue?vue&type=template&id=e4de8abc&scoped=true&"
import script from "./duoTraining.vue?vue&type=script&lang=js&"
export * from "./duoTraining.vue?vue&type=script&lang=js&"
import style0 from "./duoTraining.vue?vue&type=style&index=0&id=e4de8abc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4de8abc",
  null
  
)

export default component.exports